
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26 5.5v-.2l-3.5-5-.1.1h-.1l.1-.1-.1-.1-.1.2h-.1V.2L3.9 0l-.2.1-3.7 5v.4l12.6 14.3.2.1h.4l.2-.1L25.9 5.7l.1-.2zm-8.2.3L13 17.4 8.1 5.8h9.7zm-6.5-4.6L7.4 4.4 5 1.2h6.3zM6.1 4.7H1.6l2.2-3 2.3 3zm.8 1.1L11.1 16 1.8 5.8h5.1zm2-1.1l4-3.3 4 3.3h-8zm12-3.5l-2.4 3.2-3.9-3.2h6.3zm-1.8 4.6h5L14.8 16l4.3-10.2zm.7-1.1l2.2-3 2.2 3h-4.4z","fill":"#f5a621"}})])
          )
        }
      }
    